import React from 'react';
import PropTypes from 'prop-types';
import styles from './index.css';
import errorBoundary from '@ifeng-fe/errorBoundary';
import BigModuleHead from '@src/pc/index/components/BigModuleHead';
import { formatImageWebpAuto } from '@ifeng-fe/public_method';
import Chip from 'Chip';

const Customer = ({ customerData, customerHead }) => {
    return (
        <div className={styles.customer}>
            <Chip id="260482" type="struct" title="客户专区头" content={customerHead}>
                <BigModuleHead />
            </Chip>
            <Chip id="287348" type="recommend" title="客户专区列表">
                <div className={styles.customerBox}>
                    {customerData.map((item, index) => {
                        const thumbnail = item?.thumbnails?.image?.[0]?.url || '';

                        return (
                            <a key={index} href={item.url} target="_blank" className={styles.customerItem}>
                                <div className={styles.customerPicBox}>
                                    <img
                                        className={styles.customerImage}
                                        src={formatImageWebpAuto(thumbnail, 294, 165)}
                                    />
                                </div>
                                <div className={styles.customerBorder}>
                                    <div className={styles.customerTitle}>{item.title}</div>
                                    <div className={styles.customerBref}>
                                        {item.summary}
                                        <div className={styles.customerBrefMore}>[详情]</div>
                                    </div>
                                </div>
                            </a>
                        );
                    })}
                </div>
            </Chip>
        </div>
    );
};

Customer.propTypes = {
    customerData: PropTypes.array,
    customerHead: PropTypes.object,
};

export default errorBoundary(Customer);
